import { Slider } from "@/components/ui/slider";
import { Label } from "@/components/ui/label";

export const SKILL_AREAS = [
  { key: "serve", label: "Serve" },
  { key: "return", label: "Return" },
  { key: "volley", label: "Volleyspel" },
  { key: "bandeja", label: "Bandeja / Víbora" },
  { key: "wall_play", label: "Väggspel" },
  { key: "smash", label: "Smash" },
  { key: "footwork", label: "Fotarbete" },
  { key: "tactics", label: "Taktik / Spelförståelse" },
] as const;

interface Props {
  ratings: Record<string, number>;
  onChange: (ratings: Record<string, number>) => void;
}

export default function PlayerSkillRating({ ratings, onChange }: Props) {
  const handleChange = (key: string, value: number[]) => {
    onChange({ ...ratings, [key]: value[0] });
  };

  return (
    <div className="space-y-3">
      <p className="text-xs font-medium text-muted-foreground">Bedömning (1–5)</p>
      {SKILL_AREAS.map((area) => (
        <div key={area.key} className="space-y-1">
          <div className="flex items-center justify-between">
            <Label className="text-xs">{area.label}</Label>
            <span className="text-xs font-semibold text-primary">{ratings[area.key] || "–"}</span>
          </div>
          <Slider
            min={1}
            max={5}
            step={1}
            value={[ratings[area.key] || 3]}
            onValueChange={(v) => handleChange(area.key, v)}
            className="w-full"
          />
        </div>
      ))}
    </div>
  );
}
